import { API_BASE_URL } from 'core/integrations/api/config';

export const getAuthToken = `${API_BASE_URL}auth/linkedin`;
